import CRUDService from "../services/base/CRUDService";

export default class MapService extends CRUDService {

  static ALL_URL = "polygon/v1/maps/";

  getBaseURL() {
    return MapService.ALL_URL;
  }

  findLsdByReadpointAndDate(readpointId, date) {
    return this.httpRequest.get(`polygon/v1/readpoints/${readpointId}/movements/last/lsd?limitDate=${date}`);
  }

}



// WEBPACK FOOTER //
// ./src/map/MapService.js